import React, { useState } from 'react';
import { connect } from 'react-redux';

import { toggleModal } from 'apps/auth/actions/appAction';
import { updateExtraByName } from 'apps/auth/actions/extraAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { apiFetchData } from 'apps/auth/helpers/api';
import { useExtra } from 'apps/auth/hooks/selectors';

const ProfileFlogs = (props) => {
    const { flagsExtras } = useExtra();
    const [flagKey, setFlagKey] = useState('');
    const [flagValue, setFlagValue] = useState('');

    const inputStyle = {
        border: '1px solid #9f9da3',
        borderRadius: '6px',
        fontSize: '17px',
        width: '350px',
        marginBottom: '4px',
    };
    const removeFlag = (key) => {
        apiFetchData(`/auth/remove/flag`, {
            key: {
                name: 'key',
                value: key,
            },
        }).then((result) => {
            if (result) {
                const newFlags = { ...flagsExtras };
                delete newFlags[key];
                flagsExtras && props.updateExtraByName('flagsExtras', newFlags);
            }
        });
    };

    const addFlag = (key, value) => {
        apiFetchData(`/auth/add/flag`, {
            key: {
                name: 'key',
                value: key,
            },
            value: {
                name: 'value',
                value: value,
            },
        }).then((result) => {
            if (result) {
                const newFlags = { ...flagsExtras };
                newFlags[key] = value;
                flagsExtras && props.updateExtraByName('flagsExtras', newFlags);
                setFlagKey('');
                setFlagValue('');
            }
        });
    };
    const allow = !__isProd__ && (__isDev__ || __isTest__);
    const envBlock = (
        <Row indent="24px">
            <strong>__isDev__: </strong>
            <span>{String(__isDev__)}</span>
            <br />
            <br />
            <strong>__isTest__: </strong>
            <span>{String(__isTest__)}</span>
            <br />
            <strong>__isProd__: </strong>
            <span>{String(__isProd__)}</span>
        </Row>
    );
    if (allow && flagsExtras) {
        return (
            <>
                <HeaderPanel title={'[Extras] Flags'} />
                {envBlock}
                <div>
                    <Row indent="24px">
                        <strong>Key: </strong>
                        <input style={inputStyle} type="text" value={flagKey} onChange={(e) => setFlagKey(e.target.value)} />
                        <br />
                        <strong>Value: </strong>
                        <input style={inputStyle} type="text" value={flagValue} onChange={(e) => setFlagValue(e.target.value)} />
                        <br />
                        <Button type="button" variant="primary" raised={true} caption={`Add`} onClick={() => addFlag(flagKey, flagValue)} />
                    </Row>
                </div>
                <div style={{ wordWrap: 'break-word' }}>
                    {Object.entries(flagsExtras).map(([key, value]) => {
                        return (
                            <Row indent="24px" key={key}>
                                <strong>Key: </strong>
                                <span>{key}</span>
                                <br />
                                <strong>Value: </strong>
                                <span>{value}</span>
                                <br />
                                <Button type="button" variant="danger" raised={true} caption={`Remove`} onClick={() => removeFlag(key)} />
                            </Row>
                        );
                    })}
                </div>
            </>
        );
    }
};

export default connect(null, { updateExtraByName, toggleModal })(ProfileFlogs);
